import axios from 'axios'
import { getProjectAssetsWithFilters } from '../projects/actionCreator'

import {
  FETCH_ASSET_METADATA,
  RESET_ASSET_METADATA,
  FETCH_ASSET_REVISIONS,
  DELETE_ASSET_REVISIONS,
  FETCH_CATALOG,
  SET_UNSAVEDCHANGES_FLAG,
  CLEAR_ASSET_REVISIONS,
  SET_METADATA_LOADING,
  SAVE_SELECTED_ASSET_METADATA,
  SET_GOLD_STANDARD_LOADING,
  SET_BULK_EDIT_ASSET_IDS,
} from './actionTypes'
import { showNotification } from '../notification/actionCreator'

import apiConfig from '../../config/apiConfig'
import { NOTIFICATION_SUCCESS_REVISION_DELETE } from '../../constants/metadata'
import { setDeleteAssetInProgress } from '../search/actions'
import firefly from '../../analytics/firefly'
import {
  disableAssetLoader,
  enableAssetLoader,
  enableTriggerSearchCall,
} from '../../betasearch/store/search/searchSlice'
import { Search } from '../../helpers/UtilityHelper'

const { key: KEY = '', metadata = {} } = apiConfig
const {
  locationKey: LOCATION_KEY = '',
  assetMetadataUrl,
  updateAssetMetadataUrl,
  assetDeleteUrl,
  drmUrl,
  productUrl,
  locationUrl,
  catalogUrl,
} = metadata

export const toggleGoldStandardData =
  (payload, isEmpty = false) =>
  async (dispatch) => {
    try {
      if (!isEmpty) {
        dispatch({ type: SET_GOLD_STANDARD_LOADING, payload: true })
        const response = await axios.get(
          `${assetMetadataUrl}${payload.asset_uoi_id}?key=${KEY}`,
        )
        const data = response.status === 200 ? response.data : {}
        dispatch({
          type: SAVE_SELECTED_ASSET_METADATA,
          payload: {
            ...payload,
            ...data,
          },
        })
        dispatch({ type: SET_GOLD_STANDARD_LOADING, payload: false })
      } else {
        dispatch({
          type: SAVE_SELECTED_ASSET_METADATA,
          payload: payload,
        })
      }
    } catch (error) {
      dispatch({
        type: SAVE_SELECTED_ASSET_METADATA,
        payload: {}, // Dispatch empty payload in case of error
      })
      dispatch({ type: SET_GOLD_STANDARD_LOADING, payload: false })
    }
  }

export const fetchAssetMetadata =
  (assetId, callbackSuccess = () => {}, callbackFailure = () => {}) =>
  (dispatch) => {
    const promise = axios.get(`${assetMetadataUrl}${assetId}?key=${KEY}`)
    dispatch(clearAssetRevisions())
    dispatch(dispatchAssetMetadata(promise))
    promise
      .then((response) => {
        callbackSuccess(response.data)
      })
      .catch((error) => {
        callbackFailure(error)
      })
  }

export const setMetadataLoading = (payload) => ({
  type: SET_METADATA_LOADING,
  payload,
})

export const dispatchAssetMetadata = (payload) => ({
  type: FETCH_ASSET_METADATA,
  payload: payload,
})

export const resetAssetMetadata = () => (dispatch) =>
  dispatch({
    type: RESET_ASSET_METADATA,
    payload: [],
  })

export const fetchRevisions = (assetMasterId) => (dispatch) => {
  const promise = axios.get(
    `${assetMetadataUrl}${assetMasterId}/revisions?key=${KEY}`,
  )
  dispatch(dispatchRevisions(promise))
}

export const dispatchRevisions = (payload) => ({
  type: FETCH_ASSET_REVISIONS,
  payload: payload,
})

export function deleteRevisionsService(payload = {}) {
  return axios.delete(`${assetDeleteUrl}?key=${KEY}`, {
    data: payload,
  })
}

export function deleteRevisions(
  payload = {},
  notificationMessage = NOTIFICATION_SUCCESS_REVISION_DELETE,
  projectId,
  pagination = {},
  callBack = () => {},
) {
  return (dispatch) => {
    deleteRevisionsService(payload)
      .then(() => {
        dispatch(setDeleteAssetInProgress(false))
        dispatch(showNotification(true, notificationMessage, 'success'))
        callBack()
        if (projectId) {
          dispatch(getProjectAssetsWithFilters(projectId, pagination))
        }
      })
      .catch((err) => {})
  }
}

export const dispatchDeleteRevisions = (payload) => ({
  type: DELETE_ASSET_REVISIONS,
  payload: payload,
})

export const fetchUsageRights = (drmIds, identifier, callback) => {
  axios
    .get(`${drmUrl}/${drmIds}?key=${KEY}`)
    .then((response) => {
      callback({ drmIds, identifier }, response.data, 'success')
    })
    .catch((response) => {
      callback({ drmIds, identifier }, response, 'failure')
    })
}

export const fetchProductData = (fieldName, keyword, identifier, callback) => {
  axios
    .get(`${productUrl}?${fieldName}=${keyword}&key=${KEY}`)
    .then((response) => {
      callback({ keyword, identifier }, response.data, 'success')
    })
    .catch((response) => {
      callback({ keyword, identifier }, response, 'failure')
    })
}

export const fetchStoreLocationData = (storeNo, identifier, callback) => {
  axios
    .get(`${locationUrl}${storeNo}?key=${LOCATION_KEY}`, {
      headers: {
        'x-api-key': LOCATION_KEY,
        Authorization: false,
      },
    })
    .then((response) => {
      callback({ storeNo, identifier }, response.data, 'success')
    })
    .catch((response) => {
      callback({ storeNo, identifier }, response, 'failure')
    })
}

export const fetchCatalogData =
  (catalog = []) =>
  (dispatch) => {
    if (catalog.length) {
      const catalogType = catalog.join(',')
      const promise = axios.get(
        `${catalogUrl}?catalogType=${catalogType}&key=${KEY}`,
      )
      dispatch(dispatchCatalog(promise))
    }
  }

export const dispatchCatalog = (payload) => ({
  type: FETCH_CATALOG,
  payload: payload,
})

export const updateMetadata = (
  payload,
  callback,
  updateMetadata,
  lanId = '',
  consumer = '',
) => {
  const saveMetadataUrl = `${updateAssetMetadataUrl}?key=${KEY}`
  axios.put(saveMetadataUrl, payload).then((response) => {
    firefly.trackMetadataUpdate(updateMetadata, lanId, consumer)

    callback(updateMetadata, response.data, 'success')
  })
}

export const updateBulkMetadata =
  (payload, lanId = '', callback, consumer = '', searchView = Search) =>
  async (dispatch) => {

    const saveBulkMetadataUrl = `${updateAssetMetadataUrl}?key=${KEY}`
    try {
      const response = await axios.put(saveBulkMetadataUrl, payload)
      firefly.trackBulkMetadataUpdate(payload, lanId, consumer)
      dispatch(
        showNotification(
          true,
          'Successfully updated metadata',
          'success',
          5000,
        ),
      )
      callback(response.data, 'success', searchView, payload)
    } catch (error) {
      // Error handled by notification system
    }
  }

export const isMetadataFormEdited = (unsavedChanges = false) => ({
  type: SET_UNSAVEDCHANGES_FLAG,
  unsavedChanges,
})

export const setBulkEditAssetIds = (assetIds = []) => ({
  type: SET_BULK_EDIT_ASSET_IDS,
  payload: assetIds,
})

export const clearAssetRevisions = () => ({
  type: CLEAR_ASSET_REVISIONS,
  payload: { assetRevisions: [] },
})

// Archived tcin(s)
export const tcinArchived = (payload, item) => async (dispatch) => {
  try {
    let response = await axios.post(
      `${apiConfig.betaSearch.archived}${item}`,
      payload,
    )
    dispatch(enableAssetLoader())
    if (response.status === 200) {
      dispatch(showNotification(true, response.data, 'success'))
      dispatch({
        type: 'search/saveSelectedItems',
        payload: { selectedItems: [] },
      })
      setTimeout(() => {
        dispatch(enableTriggerSearchCall())
      }, 5000)
    }
  } catch (err) {
    dispatch(disableAssetLoader())
  }
}
